/**
 * Where each tab of the bar was left, so going back to it lands there (a menu in the editor, a
 * dish); a tap on the tab already open goes to its first level. Kept while the app runs, for one
 * business. A link from one tab into another (the pencil at a dish of a menu) keeps the place too.
 */

/** Views without a tab of their own light up the tab they belong to. */
export const TAB_OF: Record<string, string> = { speisekarte: "speisekarten", speise: "kataloge", getraenke: "kataloge", getraenk: "kataloge", allergene: "kataloge", kategorien: "kataloge", tags: "kataloge", textbausteine: "kataloge", uebersetzungen: "kataloge", "texte-pruefen": "kataloge", import: "kataloge", einlesen: "kataloge", ausverkauft: "netz", wochenplan: "netz" };

export const left = { workspace: "", at: new Map<string, string>() };

/** The tab of a route: „speisekarte“ is under „speisekarten“. */
export const tabOf = (route: string) => TAB_OF[route] ?? route;

/** Keeps where the tab open now was left, before going elsewhere by a link. */
export function rememberHere() {
  const route = location.hash.replace(/^#\/?/, "").split(/[/?]/)[0] || "speisekarten";
  left.at.set(tabOf(route), location.hash);
}
